import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_ATTENDANCE_SHIFTS, SET_EMPLOYEE_ATTENDANCE_SHIFT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_ATTENDANCE_SHIFT_ISLOADING,
  DELETE_EMPLOYEE_ATTENDANCE_SHIFT,
  EDIT_EMPLOYEE_ATTENDANCE_SHIFT,
  GET_EMPLOYEE_ATTENDANCE_SHIFTS,
  GET_EMPLOYEE_ATTENDANCE_SHIFT,
  REGISTER_EMPLOYEE_ATTENDANCE_SHIFT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeAttendanceShift from '@/services/employee_attendance_shift';
import { Module } from 'vuex';
import { EditEmployeeAttendanceShift, RegisterEmployeeAttendanceShift, GetEmployeeAttendanceShift } from '@/dtos/employee_attendance_shift.dto';

const employeeAttendanceShift: Module<any, {}> = {
  state: {
    employeeAttendanceShift: {
      data: null,
      isLoading: false,
    },
    employeeAttendanceShifts: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeAttendanceShift: (state: { employeeAttendanceShift: any }) => state.employeeAttendanceShift,
    employeeAttendanceShifts: (state: { employeeAttendanceShifts: any }) => state.employeeAttendanceShifts,
  },
  mutations: {
    [SET_EMPLOYEE_ATTENDANCE_SHIFT]: (
      state: { employeeAttendanceShift: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAttendanceShift.data = payload.data) : null,
        (state.employeeAttendanceShift.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_ATTENDANCE_SHIFTS]: (
      state: { employeeAttendanceShifts: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAttendanceShifts.data = payload.data) : null,
        (state.employeeAttendanceShifts.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAttendanceShift.registerEmployeeAttendanceShift(
        payload as RegisterEmployeeAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ATTENDANCE_SHIFTS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFTS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAttendanceShift.getEmployeeAttendanceShifts(
        payload as GetEmployeeAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ATTENDANCE_SHIFTS, { data: result.data.data, isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFTS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAttendanceShift.getEmployeeAttendanceShifts(
        payload as GetEmployeeAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAttendanceShift.editEmployeeAttendanceShift(
        payload as EditEmployeeAttendanceShift
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_ATTENDANCE_SHIFT]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAttendanceShift.deleteEmployeeAttendanceShift(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_ATTENDANCE_SHIFT_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFT, { isLoading: false });
      commit(SET_EMPLOYEE_ATTENDANCE_SHIFTS, { isLoading: false });
    },
  },
};

export default employeeAttendanceShift;
